import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'

import {
  MarkdownContainer,
} from './Markdown.css.js';

const Markdown = ({ config, body }) => {
  const { backgroundColor, isSection } = config;

  return (
    <MarkdownContainer
      backgroundColor={backgroundColor}
      isSection={isSection}
    >
      <ReactMarkdown
        source={body}
        escapeHtml={false}
      />
    </MarkdownContainer>
  );
}

Markdown.propTypes = {
  config: PropTypes.shape({
    backgroundColor: PropTypes.string,
    isSection: PropTypes.bool,
  }),
  body: PropTypes.string.isRequired
}

Markdown.defaultProps = {
  config: {
    backgroundColor: `light-grey`,
    isSection: true,
  },
};

export default Markdown;
